export const DISPLAY_BANNER = 'DISPLAY_BANNER'
export const SESSION_PROVIDER_BANNER = 'SESSION_PROVIDER_BANNER'

export interface DisplayBanner {
    type: typeof DISPLAY_BANNER;
    payload:  boolean;
}
